/* Card videos: if a 720p rendition is missing, fall back to the original file */
(function () {
  'use strict';
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (!t || t.tagName !== 'SOURCE') return;
    var fb = t.getAttribute('data-hq-fallback');
    if (!fb || t.getAttribute('data-fb-done') || t.getAttribute('src') === fb) return;
    t.setAttribute('data-fb-done', '1');
    t.setAttribute('src', fb);
    var v = t.parentElement;
    if (v && v.tagName === 'VIDEO') {
      try { v.load(); } catch (err) {}
      if (v.autoplay) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
  }, true);
})();

/* Quick-view drawer: size chart, urgency counters, button border */
(function () {
  'use strict';

  function addStyle() {
    var st = document.createElement('style');
    st.textContent = '.wt__quick-buy .wt-button--secondary{border-color:#d6d6d6 !important;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function fillCounters(scope) {
    var path = null;
    var link = scope.querySelector('a[href*="/products/"]');
    if (link) { try { path = new URL(link.getAttribute('href'), location.origin).pathname; } catch (e) {} }
    if (!path) path = location.pathname;

    var stockEl = scope.querySelector('span[id="random-stock"]');
    if (stockEl && !stockEl.textContent.trim()) {
      var key = 'fakeStockData-' + path, now = Date.now(), d = null;
      try { d = JSON.parse(localStorage.getItem(key)); } catch (e) {}
      if (!d || !d.timestamp || (now - d.timestamp) > 24 * 60 * 60 * 1000) {
        d = { stock: Math.floor(Math.random() * 15) + 2, timestamp: now };
      }
      try { localStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
      stockEl.textContent = d.stock;
    }

    var pplEl = scope.querySelector('span[id="random-people"]');
    if (pplEl && !pplEl.textContent.trim()) {
      var k2 = 'liveViewers-' + path;
      var cur = parseInt(localStorage.getItem(k2), 10);
      if (!cur || isNaN(cur)) cur = Math.floor(Math.random() * 235) + 45;
      if (cur < 45) cur = 45;
      if (cur > 279) cur = 279;
      try { localStorage.setItem(k2, String(cur)); } catch (e) {}
      pplEl.textContent = cur;
    }
  }

  function arm() {
    addStyle();
    document.querySelectorAll('.wt__quick-buy').forEach(function (qb) {
      if (qb.__qvCountersObserved) return;
      qb.__qvCountersObserved = true;
      new MutationObserver(function () { fillCounters(qb); }).observe(qb, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trig = e.target.closest('.wt__quick-buy .size-chart-trigger');
    if (!trig) return;
    var qb = trig.closest('.wt__quick-buy');
    var src = qb && qb.querySelector('.size-modal');
    if (!src) return;
    var m = src.cloneNode(true);
    m.removeAttribute('id');
    m.setAttribute('data-qv-size-chart', '');
    m.classList.add('active');
    document.body.appendChild(m);
    document.body.style.overflow = 'hidden';
    function close() {
      m.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', esc, true);
    }
    function esc(ev) { if (ev.key === 'Escape') close(); }
    m.addEventListener('click', function (ev) {
      var closer = ev.target.closest ? ev.target.closest('[id=closeSizeChart], .size-close, .close-btn') : null;
      if (ev.target === m || closer) close();
    });
    document.addEventListener('keydown', esc, true);
  }, true);
})();

/* Quick-view BUY NOW: Shiprocket caches the page product on product pages, so
   the stock buyProduct handler cannot check out a different product from the
   quick-view drawer. Build the item from the drawer form and use buyDirect. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('.wt__quick-buy .sr-headless-checkout');
    if (!btn || location.pathname.indexOf('/products/') === -1) return;
    var form = btn.closest('form');
    if (!form || !window.shiprocketCheckoutEvents || !shiprocketCheckoutEvents.buyDirect) return;
    e.preventDefault();
    e.stopPropagation();
    var fd = new FormData(form);
    var url = fd.get('productUrl') || (form.querySelector('a[href*="/products/"]') || {}).pathname;
    var vid = String(fd.get('id') || '');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    if (!url || !vid) return;
    fetch(url.split(/[?#]/)[0] + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
        if (!v) return;
        var img = v.featured_image ? v.featured_image.src : (p.media && p.media[0] ? p.media[0].src : p.featured_image);
        shiprocketCheckoutEvents.buyDirect({
          type: 'product',
          products: [{
            productId: p.id,
            title: v.name || p.title,
            variantId: v.id,
            variantTitle: v.public_title ? v.title : '',
            price: parseFloat((v.price / 100).toFixed(2)),
            quantity: qty,
            image: img,
            item_meta_data: { properties: v.properties },
            customAttributes: {},
            vendor: p.vendor,
            product_type: p.type
          }]
        });
      })
      .catch(function () {});
  }, true);
})();

/* Section and card videos are rendered with preload="none" and no autoplay,
   so nothing downloads until it is near the viewport (and hidden desktop/mobile
   variants never download). Near the viewport they start exactly like autoplay, and pause again once
   scrolled well out of view (saves data and battery). */
(function () {
  'use strict';
  function start(v) {
    v.muted = true;
    v.autoplay = true;
    v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  /* Card videos wait for the first touch/tap/key or a real scroll: the poster is painted
     instantly and Largest Contentful Paint settles on the poster instead of the
     video's first frame. Any interaction (which is how a shopper reaches them)
     starts the visible ones. */
  var gate = false, queued = [];
  /* Start at most two videos at a time (nearest the top first); the next one
     begins as soon as a running one has its first frames (or after 3s). Eight
     clips fighting for the same bandwidth made every one of them slow. */
  var active = 0, MAX_PARALLEL = 2, pending = [];
  function schedule(v) {
    if (v.__started || pending.indexOf(v) !== -1) return;
    pending.push(v);
    pump();
  }
  function pump() {
    pending.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    while (active < MAX_PARALLEL && pending.length) {
      var v = pending.shift();
      if (!v.__visible || v.__started) continue;
      v.__started = true;
      active++;
      (function (v) {
        var done = false;
        function rel() { if (done) return; done = true; active--; pump(); }
        v.addEventListener('canplay', rel, { once: true });
        v.addEventListener('error', rel, { once: true });
        setTimeout(rel, 3000);
      })(v);
      start(v);
    }
  }
  function openGate() {
    if (gate) return;
    gate = true;
    queued.splice(0).forEach(function (v) { if (v.__visible && !v.__started) schedule(v); });
  }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (e) {
    window.addEventListener(e, openGate, { once: true, passive: true, capture: true });
  });
  /* a real scroll (not a resize-induced scroll event at the top of the page) */
  function onScroll() { if (window.scrollY > 50) { openGate(); window.removeEventListener('scroll', onScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      /* Product-gallery clips (data-autoplay-now) sit in a horizontal swiper: the next
         slide peeks 8px into the viewport, which used to start an 11 MB download the
         shopper never asked for. They count as visible only when at least half on screen. */
      var vis = en.isIntersecting;
      if (vis && v.hasAttribute('data-autoplay-now') && en.intersectionRatio < 0.5) {
        var r = en.boundingClientRect, w = window.innerWidth || document.documentElement.clientWidth;
        if (r.left < 0 || r.right > w) vis = false; /* horizontally clipped = a peeking slide */
      }
      v.__visible = vis;
      if (vis) {
        if (v.__started) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (gate || v.hasAttribute('data-autoplay-now')) { schedule(v); }
        else if (queued.indexOf(v) === -1) queued.push(v);
      } else if (v.__started && !v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: [0, 0.5] }) : null;
  function watch(root) {
    (root.querySelectorAll ? root.querySelectorAll('video[data-autoplay="true"]') : []).forEach(function (v) {
      if (v.__armed) return;
      v.__armed = true;
      if (io) io.observe(v); else start(v);
    });
  }
  function arm() {
    watch(document);
    /* cards injected later (recommendations, recently viewed, load more, search) */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ns = muts[i].addedNodes;
        for (var k = 0; k < ns.length; k++) if (ns[k].nodeType === 1) watch(ns[k]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();

/* Accessibility: decorative videos get an empty captions track */
(function () {
  'use strict';
  function fix() {
    document.querySelectorAll('video').forEach(function (v) {
      if (v.querySelector('track[kind="captions"]')) return;
      var t = document.createElement('track');
      t.kind = 'captions';
      t.label = 'English';
      t.srclang = 'en';
      t.src = 'data:text/vtt;base64,V0VCVlRUCg==';
      v.appendChild(t);
    });
  }
  window.addEventListener('load', function () {
    setTimeout(fix, 1500);
    setTimeout(fix, 5000);
  });
})();


/* Hero slideshow: slides 2+ carry data-src/data-srcset (Swiper lazy format).
   Swiper loads them on slide change; this also hydrates them all shortly after
   window load or on first interaction so rotation never shows a blank frame. */
(function () {
  'use strict';
  var done = false;
  function hydrate() {
    if (done) return;
    done = true;
    document.querySelectorAll('img.swiper-lazy[data-src], img.swiper-lazy[data-srcset]').forEach(function (img) {
      var ss = img.getAttribute('data-srcset'), sz = img.getAttribute('data-sizes'), s = img.getAttribute('data-src');
      if (sz) { img.setAttribute('sizes', sz); img.removeAttribute('data-sizes'); }
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
      if (s) { img.setAttribute('src', s); img.removeAttribute('data-src'); }
      img.classList.add('swiper-lazy-loaded');
    });
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (e) {
    window.addEventListener(e, hydrate, { once: true, passive: true, capture: true });
  });
  function afterLoad() { setTimeout(hydrate, 1200); }
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);
})();

/* INP: a variant tap paints the selected chip first; the heavy recalculation
   (price/stock/gallery/URL update) runs in the next task after that frame. */
(function () {
  'use strict';
  function afterPaint(fn) {
    if (document.visibilityState === 'hidden') { setTimeout(fn, 0); return; }
    requestAnimationFrame(function () { setTimeout(fn, 0); });
  }
  function patch() {
    var VO = customElements.get('variant-options');
    if (!VO) return false;
    if (VO.__wtInpPatched) return true;
    var orig = VO.prototype.onVariantChange;
    if (typeof orig !== 'function') return true;
    var patched = function () {
      var self = this, args = arguments;
      return new Promise(function (resolve) {
        afterPaint(function () { resolve(orig.apply(self, args)); });
      });
    };
    VO.prototype.onVariantChange = patched;
    document.querySelectorAll('variant-options').forEach(function (el) {
      el.removeEventListener('change', orig);
      el.addEventListener('change', patched);
    });
    VO.__wtInpPatched = true;
    return true;
  }
  function boot() {
    if (!patch() && window.customElements && customElements.whenDefined) {
      customElements.whenDefined('variant-options').then(patch);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Deferred video posters: reels/video sections render data-poster instead of
   poster, so their 600px preview images (7-11 per reel, ~100 KB each) no longer
   download before the hero paints. The poster is applied once the page has
   loaded (or on the first touch/scroll), for any video within ~1000px of the
   viewport; later ones as they approach. */
(function () {
  'use strict';
  var gate = false, io = null;
  function apply(v) {
    var p = v.getAttribute('data-poster');
    if (!p) return;
    /* poster overlay images rendered next to the video (hero.liquid defer_video) */
    var wrap = v.parentElement;
    for (var i = 0; i < 3 && wrap; i++) {
      var imgs = wrap.querySelectorAll('img.wt-defer-poster[data-src]');
      if (imgs.length) { imgs.forEach(function (img) { img.setAttribute('src', img.getAttribute('data-src')); img.removeAttribute('data-src'); }); break; }
      wrap = wrap.parentElement;
    }
    v.setAttribute('poster', p);
    v.removeAttribute('data-poster');
    /* Chrome drops a poster that was added around the time the clip loads its metadata
       (the reels script sets preload=metadata on every clip). Re-running load() once the
       metadata is in restores it; only for clips that are not playing. */
    function reshow() {
      if (v.__posterReloaded || v.__started || !v.paused) return;
      v.__posterReloaded = true;
      try { v.load(); } catch (e) {}
    }
    if (v.readyState > 0) reshow();
    else v.addEventListener('loadedmetadata', reshow, { once: true });
    if (io) io.unobserve(v);
  }
  function openGate() {
    if (gate) return;
    gate = true;
    document.querySelectorAll('video[data-poster]').forEach(function (v) { if (v.__near) apply(v); });
  }
  io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      en.target.__near = en.isIntersecting;
      if (en.isIntersecting && gate) apply(en.target);
    });
  }, { rootMargin: '1000px 0px' }) : null;
  function watch(root) {
    (root.querySelectorAll ? root.querySelectorAll('video[data-poster]') : []).forEach(function (v) {
      if (v.__posterArmed) return;
      v.__posterArmed = true;
      if (io) io.observe(v); else apply(v);
    });
  }
  function arm() {
    watch(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ns = muts[i].addedNodes;
        for (var k = 0; k < ns.length; k++) if (ns[k].nodeType === 1) watch(ns[k]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (e) {
    window.addEventListener(e, openGate, { once: true, passive: true, capture: true });
  });
  window.addEventListener('scroll', function onS() { if (window.scrollY > 50) { openGate(); window.removeEventListener('scroll', onS); } }, { passive: true });
  if (document.readyState === 'complete') setTimeout(openGate, 300); else window.addEventListener('load', function () { setTimeout(openGate, 300); });
  setTimeout(openGate, 4000);
  /* product gallery: once the page is idle, give every remaining slide its poster so a
     swipe never lands on a blank frame */
  function galleryAll() { document.querySelectorAll('gallery-section video[data-poster]').forEach(apply); }
  if (document.readyState === 'complete') setTimeout(galleryAll, 2500); else window.addEventListener('load', function () { setTimeout(galleryAll, 2500); });
})();

/* Hidden drawers (search suggestions, cart upsell) render their images with
   data-src/data-srcset (card.liquid defer_images, cart-upsell.liquid): browsers
   were fetching ~500 KB of them on every page load. They are applied the moment
   the drawer opens (or its trigger / add-to-cart is tapped), and again for any
   images injected later while the drawer is open. */
(function () {
  'use strict';
  function hydrateIn(root) {
    if (!root) return;
    root.querySelectorAll('img.wt-defer-img').forEach(function (img) {
      var ss = img.getAttribute('data-srcset'), s = img.getAttribute('data-src');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
      if (s) { img.setAttribute('src', s); img.removeAttribute('data-src'); }
      img.classList.remove('wt-defer-img');
    });
  }
  var search = function () { return document.querySelector('.wt-drawer-search'); };
  var cart = function () { return document.querySelector('cart-drawer, .wt-cart__drawer'); };
  function arm() {
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.wt-header__search-trigger, .wt-drawer-search, a[href="/search"]')) hydrateIn(search());
      if (t.closest('#cart-icon-bubble, .wt-cart__trigger, a[href="/cart"], cart-drawer, .wt-cart__drawer, product-form, .wt__quick-buy, [name="add"], .upsell-btn')) hydrateIn(cart());
    }, true);
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.closest && e.target.closest('.wt-drawer-search')) hydrateIn(search());
    }, true);
    new MutationObserver(function () {
      var b = document.body.classList;
      if (b.contains('search-overlay-on')) hydrateIn(search());
      if (b.contains('page-overlay-cart-on')) hydrateIn(cart());
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var s = search();
    if (s) new MutationObserver(function () {
      if (s.hasAttribute('open') || s.classList.contains('wt-drawer-search--active')) hydrateIn(s);
    }).observe(s, { attributes: true, attributeFilter: ['open', 'class'] });
    var c = cart();
    if (c) new MutationObserver(function () {
      if (document.body.classList.contains('page-overlay-cart-on') || c.hasAttribute('open') || c.classList.contains('active')) hydrateIn(c);
    }).observe(c, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
